module.exports = __webpack_public_path__ + "static/img/bg-es.06ccc9e0.png";